"use client";

import { useCallback, useMemo, useState } from "react";
import type { HubExchangeAccount } from "@cede/types";
import type { ExchangeSessionResult } from "../types";
import { useParadexConnection } from "./useParadexConnection";
import { useAuthenticatedWalletConnection } from "@/hooks/core/useAuthenticatedWalletConnection";
import { WALLET_ACTION_ROLE } from "@/hooks/core/useWalletActionGuard";

export function useParadexSession(): ExchangeSessionResult {
  const paradexConnection = useParadexConnection();
  const { authenticatedWalletAddress } = useAuthenticatedWalletConnection();

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const selectedAccount = useMemo(() => {
    const accts = paradexConnection.paradexAccounts;
    if (selectedAccountId != null) return accts.find((a) => a.id === selectedAccountId) ?? null;
    return accts[0] ?? null;
  }, [paradexConnection.paradexAccounts, selectedAccountId]);

  const setSelectedAccount = useCallback(
    (account: HubExchangeAccount | null) => setSelectedAccountId(account?.id ?? null),
    [],
  );

  return {
    connection: paradexConnection,
    sessionStatus: paradexConnection.sessionStatus,
    accounts: paradexConnection.paradexAccounts,
    selectedAccount,
    setSelectedAccount,
    handleSetupAction: () => {},
    isSettingUp: false,
    requiredWalletRole: WALLET_ACTION_ROLE.MAIN_EVM,
    requiredWalletAddress: authenticatedWalletAddress ?? paradexConnection.connectedAddress,
    exchangeAccountAddress: paradexConnection.agentData.agentAddress,
    needsDeposit: false,
  };
}
